define('views/pages/SupportCenterPageView',['underscore', 'jquery', 'PageView', 'app', 'ApiRequest',
    'testEmail',
    'TagCommander',
    'InputView',
    'SelectView',
    'models/SupportCenterModel',
    'template!support-center',
    'template!blocks/support-center/search',
    'template!blocks/support-center/success',
    'template!blocks/support-center/article',
    'template!blocks/support-center/form',
], function (_, $, PageView, app, ApiRequest,
             testEmail,
             TagCommander,
             InputView,
             SelectView,
             SupportCenterModel,
             SupportCenterTemplate,
             SupportCenterSearchTemplate,
             SupportCenterSuccessTemplate,
             SupportCenterArticleTemplate,
             SupportCenterFormTemplate) {

    var view,
        inputSearchSelector = '[name="search"]',
        _CSS_OPACITY_ = 'opacity',
        _CSS_TRANSFORM_ = 'transform',
        _CSS_TRANSLATE_X0_ = 'translateX(0)',
        _CSS_TRANSLATE_Y0_ = 'translateY(0)',
        supportCenterModel,
        lastScrollTop = 0,
        isFormVisible = false,
        oldSubviews,
        type;

    return PageView.extend({
        pageName: 'SupportCenter',
        events: {
            'submit .support-center__banner__form': 'submitSearchForm',
            'click .support-center__form-toggle .btn--form': 'showForm',
            'submit .support-center__form': 'submitForm',
            'click .support-center__menu__item--section': 'changeIsFormVisible'
            //'click .support-center__categories__item a': 'displaySection',
        },

        initialize: function (options) {

            view = this;

            supportCenterModel = SupportCenterModel.getInstance();
            if(!!options.microtemplateStart){
                supportCenterModel.set(_(options).pick(['id','type']))
            }else{
                supportCenterModel.set(view.$('.support-center').data());
            }
            PageView.prototype.initialize.apply(this, arguments);
            //
            // contenu en cache
            view.listenToOnce(supportCenterModel, 'dataReady', view.initialRender);
            if (supportCenterModel.get('dataReady')) {
                view.initialRender();
            }
            view.listenTo(supportCenterModel, 'change:searchPending', view.displaySearch);

            /*view.render = _.wrap(this.render, function(render) {
                render();
                this.afterRender();
            });*/
        },
        microtemplate: function (options) {
           oldSubviews = view.subviews;
            view.pageOptions = _.defaults(options,{});;

            _(view.subviews).each(function(subview){

                subview.remove();
                subview.$el.removeData().unbind();
            });

            view.subviews = [];

            supportCenterModel = new SupportCenterModel.getInstance();
            supportCenterModel.set(options);
            PageView.prototype.initialize.apply(this, arguments);

            view.render();
        },
        startPageTagCommander:function(options) {
            TagCommander.LoadPage(this.pageName,{supportCenter:supportCenterModel});
        },
        updateInputSearch: function () {
            var inputSearch = view.$(inputSearchSelector).val();
            supportCenterModel.set('inputSearch', inputSearch);
        },
        initialRender: function () {
            view.render();
            if (app.isDesktop()) {
                view.$(inputSearchSelector).focus();
            }
        },
        render: function () {

            view.updateInputSearch();

            try {
                view.$el.html(
                    SupportCenterTemplate(supportCenterModel)
                );
            }catch(err){
                supportCenterModel.set({type:'root',id:''});
                SupportCenterTemplate(supportCenterModel);
            }

            view.initializeLinksOfPage();
            SelectView.initializeSelectsOfView(view);
            InputView.initializeInputsOfView(view);

            type = supportCenterModel.getType();
            view.stopListening(app, 'scroll');

            view.afterRender();
        },
        afterRender: function(){
            view.frameBreadcrumb();
            view.frameArticle();
            view.frameNav();
            view.frameRootNav();

            // If article height is greater than 500, bind onScroll event
            if (app.isDesktop()){
                view.listenTo(app, 'scroll', view.onScroll);
            }
            //&& $('.support-center__article').height() > 500) {
            //}
        },
        frameBreadcrumb: function () {
           var $view = $(view.el),
                o1view, o1src, o1dest, o1duration=0,
                o2view, o2src, o2dest, o2duration=0
           ;

            if (type === 'category') {

                o1src = '0';
                o1dest = '1';
                o1duration = 100;

                o2src = '1';
                o2dest = '0';
                o2duration = 500;

            } else if (type === 'article') {
                o2src = '0';
                o2dest = '1';
                o2duration = 100;

            } else if (type === 'root') {

                o1src = '1';
                o1dest = '0';
                o1duration = 500;

                o2src = '1';
                o2dest = '0';
                o2duration = 500;
            }

            function opacityTransition(oSrc,oDest,oDuration,o){
                if(oDuration>0){
                    var oView = $view.find('.level-'+o);
                    oView.css(_CSS_OPACITY_, oSrc);
                    setTimeout(function () {
                        oView.css(_CSS_OPACITY_, oDest);
                    }, oDuration);
                }
            }
            opacityTransition(o1src,o1dest,o1duration,1);
            opacityTransition(o2src,o2dest,o2duration,2);
            //
        },
        changeIsFormVisible: function () {
          isFormVisible = false;
        },
        frameArticle: function () {
            var view = this;
            view.$('.selected').on('click', function () {
               return false;
            });
            if (type !== 'category') {
                view.$('.support-center__article__body').css(_CSS_OPACITY_, '0');
                setTimeout(function () {
                    view.$('.support-center__article__body').css({
                        opacity:1,
                        transform:_CSS_TRANSLATE_X0_
                    });
                }, 200);
                view.$('.support-center__form-toggle').css(_CSS_OPACITY_, '0');
                setTimeout(function () {
                    view.$('.support-center__form-toggle').css({
                        opacity:1,
                        transform:_CSS_TRANSLATE_Y0_
                    });
                    if (app.isDesktop()
                        && type !== 'root'
                        && (view.$('.support-center__article').height() > 700 || isFormVisible)) {
                        window.scroll({
                            top: 200,
                            behavior: 'smooth'
                        });
                        isFormVisible = false;
                    }
                }, 200);

            } else {
                view.$('.support-center__article__body').css(_CSS_TRANSFORM_, _CSS_TRANSLATE_X0_);
            }
        },
        frameNav: function () {
            var view = this;
            var timeout = 100;
            if (type === 'category') {

                view.$('.support-center__category__title').css(_CSS_OPACITY_, '0');
                view.$('.support-center__menu__item--section').each(function () {
                    $(this).css(_CSS_OPACITY_, '0');
                    $(this).find('.arrow').css(_CSS_OPACITY_, '0');
                });

                setTimeout(function () {
                    view.$('.support-center__category__title').css({
                        opacity:1,
                        transform:_CSS_TRANSLATE_X0_
                    });
                    view.$('.support-center__menu__item--section').each(function () {
                        timeout += 80;
                        view.frameNavLi($(this), timeout)
                    });
                }, 200);
            } else {
                view.$('.support-center__category__title').css(_CSS_TRANSFORM_, _CSS_TRANSLATE_X0_);
                view.$('.arrow').css(_CSS_TRANSFORM_, _CSS_TRANSLATE_X0_);
                view.$('.support-center__menu__item').css(_CSS_TRANSFORM_, _CSS_TRANSLATE_X0_);
            }
        },
        frameNavLi: function ($el, timeout) {
            setTimeout(function () {
                $el.css({
                    opacity:1,
                    transform:_CSS_TRANSLATE_X0_
                });
                $el.find('.arrow').css({
                    opacity:1,
                    transform:_CSS_TRANSLATE_X0_
                });
            }, timeout);
        },
        frameRootNav: function () {
            var view = this;
            var timeout = 0,
                $menuItems = view.$('.support-center__menu__item');
            if (type === 'root') {

                $menuItems.each(function () {
                    $(this).css(_CSS_OPACITY_, '0');
                });

                setTimeout(function () {
                    $menuItems.each(function () {
                        timeout += 80;
                        view.frameNavLi($(this), timeout)
                    });
                }, 200);
            } else {
                $menuItems.css(_CSS_TRANSFORM_, _CSS_TRANSLATE_X0_);
            }
        },
        onScroll: function (e) {
            e.stopPropagation();
            e.preventDefault();
            e.stopImmediatePropagation();
            var $nav = view.$('.support-center__nav');
            if($nav.length == 0) return;

            var $article = view.$('.support-center--article');
            var requireScroll = ($article.length > 0) && ($article.height() > 500);

            var navBottom = $nav.length ? $nav.position().top + $nav.offset().top + $nav.outerHeight(true) : 0;
            var articleBottom = requireScroll ? $article.offset().top + $article.outerHeight(true) : 0;
            view.scrollTop = $(window).scrollTop();
            //
            if( !requireScroll ){
                return $nav.attr('style','');
            }else if ($(window).scrollTop() >= $article.offset().top - 40) {
                $nav.css({
                    'position': 'fixed',
                    'top': '120px',
                    'bottom': 'auto'
                });

                if (navBottom >= articleBottom) {
                    $nav.css({
                        'position': 'absolute',
                        'top': 'initial',
                        'bottom': '90px'
                    })
                }
                if($nav.offset().top - $(window).scrollTop() >= 120) {
                    $nav.css({
                        'position': 'fixed',
                        'top': '120px',
                        'bottom': 'auto'
                    });
                }
            } else if ($(window).scrollTop() < $article.offset().top) {
                $nav.css({
                    'position': 'relative',
                    'top': '0'
                });
            }

        },
        showForm: function () {
            view.$('.support-center__form-toggle .btn--form').slideToggle();
            view.$('.support-center__form').slideToggle();
            isFormVisible = true;
            // if (app.isDesktop() && $('.support-center__form').css('display') === 'block') {
            //     view.listenTo(app, 'scroll', view.onScroll);
            // }
        },

        submitSearchForm: function (e) {
            e.preventDefault();
            e.stopPropagation();
            view.updateInputSearch();
            app.go('supportCenterSearch', {
                type: 'search',
            });
            supportCenterModel.search();
        },

        displaySearch: function () {
            view.$('.support-center__search').html(SupportCenterSearchTemplate(supportCenterModel));

            view.initializeLinksOfPage();
        },

        submitForm: function (e) {
            e.preventDefault();
            e.stopPropagation();

            var form = e.currentTarget,
                $form = $(form),
                dataImage,
                file,
                currentArticle = supportCenterModel.getCurrentArticle(),
                data = {
                    subject: currentArticle.getName()
                },
                submit = $(':submit', form),
                requireValidation = [];

            // validation & data collection
            _.each(form, function (el) {
                //
                //
                //
                var key = el.name,
                    value = el.value;
                switch (key) {
                    // champs vide
                    case '':
                        break;
                    // champs d'upload
                    case 'upload':
                        file = view.$('#'+key)[0].files[0];
                        if (file) {
                            dataImage = new FormData();
                            dataImage.append('image', file);
                        }
                        break;
                    // champs d'email
                    case 'email':
                        validation = {
                            valid: testEmail(value)
                        };
                        if (!validation.valid) {
                            if (value.length > 0) {
                                validation.error = app.t("%s n'est pas un email valide", "Zendesk", [value]);
                            } else {
                                validation.error = app.t('Le champs %s est requis', 'UI', app.t("Email", "Contact"));
                            }
                            requireValidation.push(validation);
                        }
                        data[key] = value;
                        break;
                    case 'form_id':
                        data[key] = value;
                        break;
                    default:
                        var fieldId = /field__(.*)$/g.exec(key)[1],
                            field = supportCenterModel.getField(fieldId),
                            validation = field.validate(value);

                        if (!validation.valid) {
                            // TODO
                            requireValidation.push(validation);
                        }
                        data[key] = field.formatValue(value);
                }
            });

            if (requireValidation.length > 0) {
                // affichage des erreurs de saisie
                _(requireValidation).each(function (err) {
                    app.banNotice(err.error);
                });
                return;
            }

            // affichage du loader
            submit
                .addClass('loading')
                .attr('disabled', true);
            $form.addClass('locked');

            // fonction finale qui reset le formulaire
            function ResetForm() {
                $form.removeClass('locked');
                submit.removeClass('loading')
                    .attr('disabled', false);

            }

            // en cas de succès
            function Success() {
                ResetForm();
                $form.slideUp();
                //view.stopListening(app, 'scroll', view.onScroll);
                view.$('.support-center__article').append(
                    $(SupportCenterSuccessTemplate())
                );
            }

            function Error(errorMessage){
                app.alert(errorMessage);
                ResetForm();
            }

            supportCenterModel.requestContactForm(data,dataImage,Success,Error)

        }
    })

});
